import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 md:px-8 md:py-24" data-id="element-137" data-mp="1223hh69aexzq">
      <div className="mx-auto max-w-3xl" data-id="element-138" data-mp="124pqzbfqnnkl">
        <h2 className="text-center text-[28px] font-extrabold leading-tight tracking-tight text-ink-900 md:text-4xl" data-id="element-139" data-mp="1prxtjlls8iix">
          Frequently asked questions
        </h2>
        <div className="mt-10 divide-y divide-mist-200 border-y border-mist-200" data-id="element-140" data-mp="1ut557vr1q1uv">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-141" data-mp="1kzo56a0bfqir" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-142" data-mp="28rbrsfqjoff8">
                  <span className="text-[17px] font-bold text-ink-900" data-id="element-143" data-mp="2oo4hpmhwmg2g">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-brand-400 text-ink-950' : 'bg-mist-100 text-ink-900'}`} data-id="element-144" data-mp="2jsp8j7uud8cd">
                    <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-145" data-mp="37ijhvffycerv" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-146" data-mp="3hemk0lat0det">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-147" data-mp="3hcjs1vq3ca7g">
                      <p className="pb-5 text-[16px] leading-relaxed text-mist-600" data-id="element-148" data-mp="27rigkrsoosom">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <SectionCta label="Yes! Give me instant access" data-id="element-149" data-mp="2gsyq6xbocqrs" />
      </div>
    </section>;
}